/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-ref-border-color);
  --line-width: var(--nve-ref-border-width-sm);
  --target-size: var(--nve-ref-border-width-lg);
  --cursor: row-resize;
  display: block;
  contain: layout;
  cursor: var(--cursor);
  z-index: 99;
}

[internal-host] {
  width: 100%;
  height: 100%;

  ::before,
  ::after {
    display: block;
    content: ' ';
    position: absolute;
    cursor: var(--cursor);
  }
}

.line {
  transition:
    background-color var(--nve-ref-animation-duration-200) ease-in,
    outline-color var(--nve-ref-animation-duration-200) ease-in;
  background: var(--background);
  outline: 1px solid transparent;
  width: 100%;
  height: 100%;
}

:host([orientation='horizontal']) {
  height: var(--line-width);
  width: 100%;

  ::before,
  ::after {
    height: var(--target-size);
    width: 100%;
  }

  ::before {
    top: calc(-1 * var(--target-size));
  }

  ::after {
    bottom: calc(-1 * var(--target-size));
  }

  input {
    writing-mode: vertical-lr;
    direction: rtl;
  }
}

:host([orientation='vertical']) {
  --cursor: col-resize;
  width: var(--line-width);
  height: 100%;

  ::before,
  ::after {
    height: 100%;
    width: var(--target-size);
  }

  ::before {
    left: calc(-1 * var(--target-size));
  }

  ::after {
    right: calc(-1 * var(--target-size));
  }
}

:host([dir='rtl']) {
  input {
    direction: rtl;
  }
}

[internal-host]:hover,
[internal-host]:has(input:focus),
:host(:state(active)) [internal-host] {
  --background: var(--nve-sys-accent-secondary-background);

  .line {
    outline: 1px solid var(--background);
  }
}

input {
  opacity: 0;
  height: 0;
  width: 0;
  position: absolute;
}

:host(:state(active)) {
  --background: var(--nve-sys-accent-secondary-background);
}
